import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { StateMessageFactory } from "@/components/shared/state-messages/StateMessageFactory";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/success/change-password/")({
  component: ChangePasswordSuccess,
});

function ChangePasswordSuccess() {
  return (
    <div className="h-screen grid grid-col-1 p-14 items-center col-span-full">
      <div className="row-span-1 flex justify-center">
        <MimiatHorizontalLogo />
      </div>
      <div className="row-span-8 flex justify-center">
        {StateMessageFactory("change-password-success")}
      </div>
    </div>
  );
}
